import React from 'react';
import { FadeIn } from './ui';
import { FileText, Brain, Moon, Sunset, Filter } from 'lucide-react';
export const WhatYouGet = () => {
  const items = [{
    icon: <FileText size={20} strokeWidth={1.5} data-id="element-138" />,
    title: 'The 11-Minute Master Script',
    desc: 'The exact verbal sequence to trigger a mental shutdown.'
  }, {
    icon: <Brain size={20} strokeWidth={1.5} data-id="element-139" />,
    title: 'The Alpha-Word Protocol',
    desc: 'A "plug-and-play" mental game that kills internal monologues.'
  }, {
    icon: <Moon size={20} strokeWidth={1.5} data-id="element-140" />,
    title: 'The 3AM Biology Guide',
    desc: 'Understand the "Cortisol Spike" so you can stop the panic-about-the-panic.'
  }, {
    icon: <Sunset size={20} strokeWidth={1.5} data-id="element-141" />,
    title: 'The Evening Shutdown Prep',
    desc: 'A 2-minute physical routine to drain tension before your head hits the pillow.'
  }, {
    icon: <Filter size={20} strokeWidth={1.5} data-id="element-142" />,
    title: 'The 10-10-10 Rumination Filter',
    desc: 'A mental framework to categorize and "park" late-night worries until morning.'
  }];
  return <section className="py-16 px-6" data-id="element-143">
      <div className="max-w-2xl mx-auto" data-id="element-144">
        <FadeIn data-id="element-145">
          <h2 className="text-3xl text-center mb-12" data-id="element-146">Inside the Script</h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-147">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-148">
              <div className="flex gap-6 items-start group" data-id="element-149">
                <div className="p-3 rounded-full bg-surface border border-white/5 text-amber shrink-0 transition-colors group-hover:bg-midnight group-hover:border-amber/30" data-id="element-150">
                  {item.icon}
                </div>
                <div data-id="element-151">
                  <h3 className="text-xl font-medium text-parchment mb-2" data-id="element-152">
                    {item.title}
                  </h3>
                  <p className="text-parchment-muted font-light leading-relaxed" data-id="element-153">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};